// extracted by mini-css-extract-plugin
export default {"DropZoneWrapper":"OpmlImportModal_DropZoneWrapper__Vuw7R","DropAreaContainer":"OpmlImportModal_DropAreaContainer__VYUXZ"};